"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = createFirebaseInstance, exports.getFirebase = getFirebase;

var _merge2 = _interopRequireDefault(require("lodash/fp/merge")),
    _isObject2 = _interopRequireDefault(require("lodash/isObject")),
    _utils = require("./utils"),
    _actions = require("./utils/actions"),
    authActions = _interopRequireWildcard(require("./actions/auth")),
    queryActions = _interopRequireWildcard(require("./actions/query")),
    storageActions = _interopRequireWildcard(require("./actions/storage"));

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var cache = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  }, cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) return obj;
  if (null === obj || "object" !== _typeof(obj) && "function" != typeof obj) return {
    default: obj
  };

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) return cache.get(obj);
  var newObj = {},
      hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      desc && (desc.get || desc.set) ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
    }
  }

  return newObj.default = obj, cache && cache.set(obj, newObj), newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

var firebaseInstance;

function createFirebaseInstance(firebase, configs, dispatch) {
  configs.enableLogging && firebase.database && "function" == typeof firebase.database.enableLogging && firebase.database.enableLogging(configs.enableLogging);
  firebase._ = (0, _merge2.default)({
    watchers: {},
    listeners: {},
    callbacks: {},
    queries: {},
    config: configs,
    authUid: null
  }, firebase._);

  var withMeta = function withMeta(method, path, value, onComplete) {
    if ((0, _isObject2.default)(value)) {
      var prefix = "update" === method ? "updated" : "created",
          dataWithMeta = _objectSpread({}, value, _defineProperty({}, "".concat(prefix, "At"), firebase.database.ServerValue.TIMESTAMP));

      return firebase.auth().currentUser && (dataWithMeta["".concat(prefix, "By")] = firebase.auth().currentUser.uid), firebase.database().ref(path)[method](dataWithMeta, onComplete);
    }

    return firebase.database().ref(path)[method](value, onComplete);
  },
      actionCreators = (0, _actions.mapWithFirebaseAndDispatch)(firebase, dispatch, {
    signInWithPhoneNumber: authActions.signInWithPhoneNumber
  }, {
    initializeAuth: authActions.init
  });

  return firebaseInstance = Object.assign(firebase, _objectSpread({
    _reactReduxFirebaseExtended: !0,
    ref: function ref(path) {
      return firebase.database().ref(path);
    },
    set: function set(path, value, onComplete) {
      return firebase.database().ref(path).set(value, onComplete);
    },
    setWithMeta: function setWithMeta(path, value, onComplete) {
      return withMeta("set", path, value, onComplete);
    },
    uniqueSet: function uniqueSet(path, value, onComplete) {
      return firebase.database().ref(path).transaction(function (d) {
        return null === d ? value : void 0;
      }).then(function (_ref) {
        var committed = _ref.committed,
            snapshot = _ref.snapshot;

        if (!committed) {
          var newError = new Error("Path already exists.");
          return onComplete && onComplete(newError), Promise.reject(newError);
        }

        return onComplete && onComplete(snapshot), snapshot;
      });
    },
    push: function push(path, value, onComplete) {
      return firebase.database().ref(path).push(value, onComplete);
    },
    pushWithMeta: function pushWithMeta(path, value, onComplete) {
      return withMeta("push", path, value, onComplete);
    },
    remove: function remove(path, onComplete, options) {
      return queryActions.remove(firebase, dispatch, path, options).then(function () {
        return "function" == typeof onComplete && onComplete(), path;
      });
    },
    update: function update(path, value, onComplete) {
      return firebase.database().ref(path).update(value, onComplete);
    },
    updateWithMeta: function updateWithMeta(path, value, onComplete) {
      return withMeta("update", path, value, onComplete);
    },
    login: function login(credentials) {
      return authActions.login(dispatch, firebase, credentials);
    },
    reauthenticate: function reauthenticate(credentials) {
      return authActions.reauthenticate(dispatch, firebase, credentials);
    },
    handleRedirectResult: function handleRedirectResult(authData) {
      return authActions.handleRedirectResult(dispatch, firebase, authData);
    },
    logout: function logout() {
      return authActions.logout(dispatch, firebase);
    },
    updateAuth: function updateAuth(authUpdate, updateInProfile) {
      return authActions.updateAuth(dispatch, firebase, authUpdate, updateInProfile);
    },
    updateEmail: function updateEmail(newEmail, updateInProfile) {
      return authActions.updateEmail(dispatch, firebase, newEmail, updateInProfile);
    },
    updateProfile: function updateProfile(profileUpdate, options) {
      return authActions.updateProfile(dispatch, firebase, profileUpdate, options);
    },
    uploadFile: function uploadFile(path, file, dbPath, options) {
      return storageActions.uploadFile(dispatch, firebase, {
        path: path,
        file: file,
        dbPath: dbPath,
        options: options
      });
    },
    uploadFiles: function uploadFiles(path, files, dbPath, options) {
      return storageActions.uploadFiles(dispatch, firebase, {
        path: path,
        files: files,
        dbPath: dbPath,
        options: options
      });
    },
    deleteFile: function deleteFile(path, dbPath) {
      return storageActions.deleteFile(dispatch, firebase, {
        path: path,
        dbPath: dbPath
      });
    },
    createUser: function createUser(credentials, profile) {
      return authActions.createUser(dispatch, firebase, credentials, profile);
    },
    resetPassword: function resetPassword(email) {
      return authActions.resetPassword(dispatch, firebase, email);
    },
    confirmPasswordReset: function confirmPasswordReset(code, password) {
      return authActions.confirmPasswordReset(dispatch, firebase, code, password);
    },
    verifyPasswordResetCode: function verifyPasswordResetCode(code) {
      return authActions.verifyPasswordResetCode(dispatch, firebase, code);
    },
    watchEvent: function watchEvent(type, path, storeAs) {
      var options = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
      return queryActions.watchEvent(firebase, dispatch, _objectSpread({
        type: type,
        path: path,
        storeAs: storeAs
      }, options));
    },
    unWatchEvent: function unWatchEvent(type, path, queryId) {
      var options = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
      return queryActions.unWatchEvent(firebase, dispatch, _objectSpread({
        type: type,
        path: path,
        queryId: queryId
      }, options));
    },
    reloadAuth: function reloadAuth() {
      return authActions.reloadAuth(dispatch, firebase);
    },
    linkWithCredential: function linkWithCredential(credential) {
      return authActions.linkWithCredential(dispatch, firebase, credential);
    },
    promiseEvents: function promiseEvents(watchArray, options) {
      var inputAsFunc = (0, _utils.createCallable)(watchArray),
          prevData = inputAsFunc(options, firebase),
          queryConfigs = (0, _utils.getEventsFromInput)(prevData);
      return Promise.all(queryConfigs.map(function (queryConfig) {
        return queryActions.watchEvent(firebase, dispatch, queryConfig);
      }));
    },
    dispatch: dispatch
  }, actionCreators)), firebaseInstance;
}

function getFirebase() {
  if (!firebaseInstance) throw new Error("Firebase instance does not yet exist. Check your compose function.");
  return firebaseInstance;
}